module.exports = __webpack_public_path__ + "static/media/logo-mymb-color.598cceb0.svg";